import { __awaiter, __generator, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState, useDeferredValue, useEffect } from 'react';
import { styled, Grid } from '@mui/material';
import _get from 'lodash/get';
import '../../api/graphQl/brand.js';
import { ProductOperation, UNAUTHENTICATED_SEARCH_PRODUCTS } from '../../api/graphQl/product.js';
import { FallbackImage } from '../../Components/FallbackImage.js';
import '../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import { getAppConsistentParams } from '../../utils/appUtils.js';
import '../../utils/assetUtils.js';
import '../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import { changeAmazonImageUrlResolution, formatMoney } from '../../utils/stringUtils.js';
import '../../utils/broadcast.js';
import '../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'lodash/isEqual';
import 'lodash/orderBy';
import { CampaignType } from '../../types/Campaign.js';
import { getPurchaseRewardAmountForProduct, getProductUrl } from '../../utils/productUtils.js';
import '@brandclub/types';
import { RewardPillWithText } from '../components/RewardPill/RewardPillWithText.js';
import '../../types/filters.js';
import '../../types/product.js';
import '../../types/RewardAmountType.js';
import { StyledBox } from './CategoriesDropdownStyles.js';

var SCROLLBAR_WIDTH = 20;
var containerWidth = Math.min(window.innerWidth * 0.9 - SCROLLBAR_WIDTH, 900);
var KeywordBox = styled('div')({
    width: 207,
    minWidth: 207,
    marginRight: 30,
});
var ProductBox = styled('div')({
    flex: 1,
});
var Header = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: 16,
        fontWeight: 600,
        color: theme.palette.primary.main,
        paddingTop: 5,
        paddingBottom: 5,
    });
});
var Keyword = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: 14,
        fontWeight: 500,
        cursor: 'pointer',
        color: theme.palette.primary.main,
        paddingTop: 5,
        paddingBottom: 5,
    });
});
var SearchDropdownContainer = styled('div')({
    display: 'flex',
    paddingBottom: 45,
});
var NavProductsWrapper = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        gap: '45px 30px',
        marginTop: '20px',
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        a: {
            color: theme.palette.primary.main,
            textDecoration: 'none !important',
            '&:hover': {
                textDecoration: 'none !important',
            },
        },
    });
});
var NavProductContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        height: 100,
        width: 286,
        display: 'flex',
        '.image': {
            width: 100,
            height: 100,
            aspectRatio: '1/1',
            backgroundColor: '#fff',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: "0 15px 0 0",
            img: {
                maxHeight: '100%',
                maxWidth: '100%',
            },
        },
        '.price': {
            color: theme.palette.primary.main,
            fontSize: 16,
            fontWeight: 600,
        },
        '.title': {
            textDecoration: 'none',
            color: theme.palette.primary.main,
            fontSize: 12,
            fontWeight: 500,
            margin: '3px 0 7px 0',
            width: '100%',
            overflow: 'hidden',
            letterSpacing: 0.36,
            WebkitLineClamp: 2,
            lineHeight: 1.5,
            height: "3em",
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            wordBreak: 'break-word',
        },
    });
});
var NavProductCard = function (_a) {
    var product = _a.product, LinkComponent = _a.LinkComponent, onClose = _a.onClose;
    var hasActiveInstantReward = product.hasActiveInstantReward, retailPrice = product.retailPrice, title = product.title, totalRewardAmount = product.totalRewardAmount, stacklineSku = product.stacklineSku;
    var urlSearchParams = getAppConsistentParams(window.location.search);
    var img = changeAmazonImageUrlResolution(_get(product, ['imageUrls', 0]), 300);
    var purchaseRewardAmount = getPurchaseRewardAmountForProduct(product);
    var rewardPercent = !!retailPrice && !!purchaseRewardAmount ? (purchaseRewardAmount * 100) / retailPrice : 0;
    var targetUrl = getProductUrl({ title: title, stacklineSku: stacklineSku, urlSearchParams: urlSearchParams });
    return (React.createElement(LinkComponent, { to: targetUrl, onClick: onClose },
        React.createElement(NavProductContainer, null,
            React.createElement("div", { className: "image" },
                React.createElement(FallbackImage, { src: img, fallbackImage: img.replace('media.brandclub.com', 'media-api.brandclub.com'), alt: title })),
            React.createElement(Grid, { display: 'flex', flexDirection: 'column', padding: '4px 0' },
                React.createElement("div", { className: "price" }, formatMoney(retailPrice)),
                React.createElement("div", { className: "title" }, title),
                React.createElement("div", null,
                    React.createElement(RewardPillWithText, { rewardAmount: totalRewardAmount !== null && totalRewardAmount !== void 0 ? totalRewardAmount : 0, rewardCampaignType: hasActiveInstantReward ? CampaignType.DailyDealsRewardCampaign : CampaignType.PurchaseRewardCampaign, rewardPercent: rewardPercent, rewardPercentText: "reward", containerStyle: undefined, baseFontSize: 11 }))))));
};
var NavProducts = function (_a) {
    var products = _a.products, loading = _a.loading, LinkComponent = _a.LinkComponent, onClose = _a.onClose;
    if (loading) {
        return null;
    }
    return (React.createElement(NavProductsWrapper, null, products.map(function (p) {
        return React.createElement(NavProductCard, { key: p.retailerSku, product: p, LinkComponent: LinkComponent, onClose: onClose });
    })));
};
var SearchDropdown = function (_a) {
    var searchInput = _a.searchInput, brandId = _a.brandId, axios = _a.axios, apolloClient = _a.apolloClient, LinkComponent = _a.LinkComponent, onClose = _a.onClose, onSubmitSearch = _a.onSubmitSearch, abTestingTreatments = _a.abTestingTreatments, brandEntity = _a.brandEntity;
    var _b = useState([]), popularKeywords = _b[0], setPopularKeywords = _b[1];
    var _c = useState([]), suggestKeywords = _c[0], setSuggestKeywords = _c[1];
    var _d = useState(false), setLoadingSuggestKeywords = _d[1];
    var _e = useState(false), loadingProducts = _e[0], setLoadingProducts = _e[1];
    var deferredInput = useDeferredValue(searchInput);
    var _f = useState([]), products = _f[0], setProducts = _f[1];
    useEffect(function () {
        var fetchPopularKeywords = function () { return __awaiter(void 0, void 0, void 0, function () {
            var result, suggestions, filteredSuggestions, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, axios.post("/product/searchTermAutoComplete", {
                                searchText: '',
                                searchScoreByCategoryId: ((_a = brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity) === null || _a === void 0 ? void 0 : _a.searchScoreByCategory) || {},
                            })];
                    case 1:
                        result = _b.sent();
                        suggestions = _get(result, ['data', 'searchTerms'], []);
                        filteredSuggestions = suggestions.map(function (_a) {
                            var searchTerm = _a.searchTerm;
                            return ({
                                text: searchTerm,
                            });
                        });
                        setPopularKeywords(filteredSuggestions.slice(0, 9));
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _b.sent();
                        console.error('error on search suggestion', error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        setLoadingSuggestKeywords(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchPopularKeywords();
    }, [brandEntity]);
    useEffect(function () {
        var fetchSuggestKeywords = function () { return __awaiter(void 0, void 0, void 0, function () {
            var result, suggestions, filteredSuggestions, error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoadingSuggestKeywords(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, axios.post("/product/searchTermAutoComplete", {
                                searchText: deferredInput,
                                searchScoreByCategoryId: ((_a = brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity) === null || _a === void 0 ? void 0 : _a.searchScoreByCategory) || {},
                            })];
                    case 2:
                        result = _b.sent();
                        suggestions = _get(result, ['data', 'searchTerms'], []);
                        filteredSuggestions = suggestions.map(function (_a) {
                            var searchTerm = _a.searchTerm;
                            return ({
                                text: searchTerm,
                            });
                        });
                        setSuggestKeywords(filteredSuggestions.slice(0, 9));
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _b.sent();
                        console.error('error on search suggestion', error_2);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoadingSuggestKeywords(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var fetchSuggestProducts = function () { return __awaiter(void 0, void 0, void 0, function () {
            var searchRequest, treatment, data, error_3;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, 3, 4]);
                        setLoadingProducts(true);
                        searchRequest = {
                            brandIds: (brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity) ? [brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity.brandId] : brandId ? [brandId] : [],
                            sort: [],
                        };
                        if (deferredInput) {
                            searchRequest['titleInclude'] = [deferredInput];
                            searchRequest.organicSearchTerm = deferredInput;
                        }
                        treatment = (abTestingTreatments === null || abTestingTreatments === void 0 ? void 0 : abTestingTreatments.searchImprovementTreatment)
                            ? {
                                search: abTestingTreatments === null || abTestingTreatments === void 0 ? void 0 : abTestingTreatments.searchImprovementTreatment,
                            }
                            : undefined;
                        return [4 /*yield*/, apolloClient.query({
                                query: UNAUTHENTICATED_SEARCH_PRODUCTS,
                                variables: __assign(__assign({}, searchRequest), { page: {
                                        start: 0,
                                        size: 4,
                                    }, computeFacets: false, treatment: treatment }),
                            })];
                    case 1:
                        data = (_c.sent()).data;
                        setProducts((_b = (_a = data === null || data === void 0 ? void 0 : data[ProductOperation.UnauthenticatedSearch]) === null || _a === void 0 ? void 0 : _a.products) !== null && _b !== void 0 ? _b : []);
                        return [3 /*break*/, 4];
                    case 2:
                        error_3 = _c.sent();
                        console.error('error on search products on nav', error_3);
                        return [3 /*break*/, 4];
                    case 3:
                        setLoadingProducts(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        if (brandId) {
            fetchSuggestKeywords();
            fetchSuggestProducts();
        }
    }, [deferredInput, brandEntity]);
    var showsuggestKeywords = suggestKeywords.length || deferredInput.length;
    return (React.createElement(StyledBox, { style: { width: containerWidth } },
        React.createElement(SearchDropdownContainer, null,
            React.createElement(KeywordBox, null,
                React.createElement(Header, null, showsuggestKeywords ? 'Suggested searches' : 'Popular searches'),
                showsuggestKeywords
                    ? suggestKeywords.map(function (keyword, index) {
                        return (React.createElement(Keyword, { key: index, onClick: function () {
                                onSubmitSearch(keyword.text);
                            } }, keyword.text));
                    })
                    : popularKeywords.map(function (keyword, index) {
                        return (React.createElement(Keyword, { key: index, onClick: function () {
                                onSubmitSearch(keyword.text);
                            } }, keyword.text));
                    })),
            React.createElement(ProductBox, null,
                React.createElement(Header, null, searchInput ? 'Suggested products' : 'Popular products'),
                React.createElement(NavProducts, { LinkComponent: LinkComponent, loading: loadingProducts, products: products, onClose: onClose })))));
};

export { SearchDropdown as default };
//# sourceMappingURL=SearchDropdown.js.map
